import { Box, Center, Modal, Text } from '@mantine/core';
import { type OS, useDisclosure, useOs, useViewportSize } from '@mantine/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const MOBILE_OS_LIST: OS[] = ['android', 'ios'];

export const MobileOrientationModal = () => {
  const { t } = useTranslation();
  const os = useOs();
  const { width, height } = useViewportSize();

  const [opened, { open, close }] = useDisclosure(false);

  const isMobile = MOBILE_OS_LIST.includes(os);

  const isLandscape = width > height;

  // Update modal visibility when orientation changes
  useEffect(() => {
    if (isMobile && isLandscape) {
      open();
    } else {
      close();
    }
  }, [isMobile, isLandscape, open, close]);

  return (
    <Modal
      centered
      closeOnClickOutside={false} // Empty function to prevent closing
      closeOnEscape={false}
      data-test-id="mobile-orientation-modal"
      // biome-ignore lint/suspicious/noEmptyBlockStatements: empty function to prevent closing
      onClose={() => {}}
      opened={opened}
      overlayProps={{
        backgroundOpacity: 0.9,
      }}
      radius="md"
      size="md"
      withCloseButton={false}
      zIndex={1000}
    >
      <Box p="xl">
        <Center>
          <Box mb="md" style={{ fontSize: 50 }}>
            📱
          </Box>
        </Center>
        <Text fw={600} mb="md" size="xl" ta="center">
          {t('mobileOrientationModal.title')}
        </Text>
        <Text mb="xl" ta="center">
          {t('mobileOrientationModal.message')}
        </Text>
      </Box>
    </Modal>
  );
};
